import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
export function PainSection() {
  return <section className="w-full bg-zinc-900 py-16 lg:py-24" aria-labelledby="dolor-titulo" data-id="element-100" data-mp="38wltmryscqh7">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-16" data-id="element-101" data-mp="2ux40y1idct2k">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/e11febfe-435e-47a8-ac5d-3f6589221b7f.jpg" alt="Profesor de boxeo solo en un gimnasio vacío por la noche" className="w-full rounded-lg object-cover shadow-2xl shadow-black/70" data-id="element-102" data-mp="2yyfq65xbzca8" />

        <div data-id="element-103" data-mp="2bb7n7undkfbd">
          <h2 id="dolor-titulo" className="font-display text-3xl uppercase leading-tight text-white sm:text-4xl" data-id="element-104" data-mp="2bbr6beorh9qz">
            ¿Sentís que tus clases terminan siendo siempre iguales?
          </h2>

          <ul className="mt-8 space-y-5" data-id="element-105" data-mp="22bue5335xsr6">
            {pains.map(pain => <li key={pain} className="flex gap-3 border-b border-zinc-800 pb-5 last:border-0" data-id="element-106" data-mp="277rw1du2r762">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-107" data-mp="3rl7ns6pcqbzp" />
                <span className="text-base leading-relaxed text-zinc-300" data-id="element-108" data-mp="3nl5tiily4kug">{pain}</span>
              </li>)}
          </ul>

          <p className="mt-8 font-display text-xl uppercase leading-snug text-amber-400 sm:text-2xl" data-id="element-109" data-mp="gpwvzu5ydl4">
            Enseñar boxeo no es solo hacer que transpiren. Es tener un método.
          </p>
        </div>
      </div>
    </section>;
}